// Serviços de Usuários usando Axios compartilhado
import api from '../config/axios';

export async function listUsuarios() {
  // Nosso axios já retorna response.data diretamente
  return api.get('/api/usuarios');
}

export async function getUsuario(id) {
  return api.get(`/api/usuarios/${id}`);
}

export async function createUsuario(data) {
  return api.post('/api/usuarios', data);
}

export async function updateUsuario(id, data) {
  return api.put(`/api/usuarios/${id}`, data);
}

export async function deleteUsuario(id) {
  return api.delete(`/api/usuarios/${id}`);
}

export async function getUsuariosSchema() {
  return api.get('/api/schema/usuarios');
}
